import { LocalStorage } from 'quasar';

export function blockInteraction(state) {
  state.canInteract = false;
}

export function allowInteraction(state) {
  state.canInteract = true;
}

export function posActive(state) {
  state.posActive = true;
}

export function posDisabled(state) {
  state.posActive = false;
}

export function bootComplete(state) {
  state.isBooting = false;
}

export function setPosMessage(state, { message }) {
  state.posMessage = message;
}

export function updateLanguage(state, payload) {
  state.language = payload;
  LocalStorage.set('language', payload);
}

export function setConfig(state, { config }) {
  state.config = config;
}

export function flush(state) {
  state.posActive = false;
  state.canInteract = true;
}
